export default {
  pageTitle: '售后服务',
  returnAddress: '售后收货地址',
  shippingAddressAfter: '售后发货地址',
  radio1: '待审核',
  radio2: '已拒绝',
  radio3: '处理中',
  radio4: '已完成',
  radio5: '已关闭',
  order: '订单',
  SKU: 'SKU',
  userId: '用户ID',
  userPhone: '用户电话',
  postageBurden1: '端点',
  postageBurden2: '卖家',
  postageBurden3: '用户',
  createDate: '创建时间',
  origin1: 'App',
  origin2: 'm站(手机站)',
  origin3: 'Email',
  origin4: 'Facebook',
  refundStatus1: '无',
  refundStatus2: '待生成',
  refundStatus3: '待审核',
  refundStatus4: '待退款',
  refundStatus5: '退款中',
  refundStatus6: '已退款',
  SoList1: '订单id',
  SoList2: '发运包ID',
  afterSaleStatusMapping1: '待商家审核',
  afterSaleStatusMapping2: '待平台审核',
  afterSaleStatusMapping3: '处理中',
  afterSaleStatusMapping4: '售后完成',
  afterSaleStatusMapping5: '商家拒绝',
  afterSaleStatusMapping6: '平台拒绝',
  afterSaleStatusMapping7: '用户取消',
  columns1: 'ID',
  columns2: '用户ID',
  columns3: '订单ID',
  columns4: '创建时间',
  columns5: '订单关闭时间',
  columns6: '关闭方式',
  columns7: '申请维度',
  columns8: 'SKU ID',
  columns9: '订单金额',
  columns10: '支付金额',
  columns11: '运费承担方',
  columns12: '操作',
  columns13: '来源',
  columns14: '申请人',
  columns15: '状态',
  columns16: '退款',
  columns17: '系统ID',
  viewDetail: '查看详情',
  inner1: 'Admin',
  inner2: 'User',
  error1: 'id错误',
  isAppeal: '是否申诉',
  appealed: '已申诉',
  buyerName: '买家名称',
  orderNum: '订单号',
  orderAmount: '订单金额',
  orderCompleteTime: '订单完成时间',
  paymentTime: '订单支付时间',
  logisticsType: '订单物流类型',
  storeId: '店铺 ID',
  storeName: '店铺名称',
  pendingReview: '待审核',
  processing: '处理中',
  completed: '完成',
  afterSaleDetail: '售后详情 - {0}',
  afterSaleDetailTitle: '售后详情',
  orderStatus: '订单状态',
  afterSaleType: '售后类型',
  applyTime: '申请时间',
  refundAmount: '退款金额',
  reason: '原因',
  remark: '描述',
  refundTime: '退款时间',
  refundInformation: '退款时间',
  processingTime: '处理时间',
  newServiceType: '新方案类型',
  changServiceType: '修改后的服务类型',
  changReason: '修改原因',
  adjustReason: '调整原因',
  rejectReason: '拒绝原因',
  sellerProvidedANewSolution: '卖家新方案信息',
  sellerHasRejectedTheApplication: '卖方拒绝了该申请',
  agreesWithSellerSolution: '平台同意卖家方案',
  agreedWithCustomerApplication: '平台同意消费者申请',
  KilimallRejectedTheApplication: ' 平台拒绝售后',
  KilimallProvidedANewSolution: ' 平台提供的新方案',
  exchangeInformation: '换货信息',
  logisticsTrackingNumber: '物流运单号',
  agreeConfirm: '同意',
  changeSolution: '调整售后方案',
  contactBuyer: '联系买家',
  returnInfoDetails: '退货信息详情',
  Reject: '拒绝',
  remarkPlaceholder: '请填写调整方案的具体原因描述',
  rejectRemarkPlaceholder: '请填写具体原因描述',
  maxiMum: '最多',
  cancel: '取消',
  confirm: '确认',
  rejectAfterSale: '拒绝售后',
  pleaseChoose: '请选择',
  pleaseEnterTheRefundAmount: '请输入退款金额',
  pleaseEnterTheCorrectAmount: '请输入正确的金额',
  productsAmount: '产品金额',
  allReceived: '已收货',
  pendingPayment: '待支付',
  pendingConfirmation: '待确认',
  pendingDispatch: '待发货',
  inTransit: '运输中',
  CustomerArbitration: '消费者仲裁信息',
  afterSaleTime: '售后处理剩余时间',
  qualityInspectionResult: '质检结果',
  Responsible: '责任方',
  kiliMallEditProject: 'Kilimall平台修改了申请方案',
  logisticsProvider: '物流公司',
  logisticsNumber: '物流运单',
  refundMethod: '退货方式',
  pickupAddress: '寄货地址',
  shippingAddress: '收货地址',
  returnInfo: '退货详情',
  returnInfoRouter: '退货详情 - {0}',
  returnLogisticsTrack: '退货物流追踪'

}
